import { apiGetAuth, apiDeleteAuth, apiPostAuth, apiPutAuth } from '@/utils/api'
import { API_USER } from '@/utils/api-url'
import {
  notificationDanger
} from '@/utils/notification'

const state = {
  user_list: {
    isLoading: false,
    data: false
  },
  detail_user: {
    isLoading: false,
    data: false
  },
  meta_filter: {
    order_by: 'updated_at',
    sort_by: 'desc'
  },
  data_modal_add_edit: {},
  toggle_modal_add_edit_discard: {
    targetModals: false,  
    title: '',
    description: '',
    type: '',
    customTitleBtnOk: '',
    customTitleBtnCancel: '',
    customClass: '',
    loadingTable: false,
    loadingPopUp: false
  }
  
}

const mutations = {
  "SET_USER_LIST": (state, payload) => {
    state.user_list = payload
  },
  "SET_DETAIL_USER": (state, payload) => {
    state.detail_user = payload
  },
  "SET_DATA_MODAL_ADD_EDIT": (state, payload) => {
    state.data_modal_add_edit = payload
  },
  "SET_TOGGLE_MODAL_ADD_EDIT_DISCARD": (state, payload) => {
    state.toggle_modal_add_edit_discard = payload
  },
  "SET_META_FILTER": (state, payload) => {
    state.meta_filter = payload
  }
}

const actions = {
  async getUserList(context, payload) {
    try {
      context.commit('SET_USER_LIST', {isLoading: true})
      const response = await apiGetAuth(API_USER.LIST, payload)
      context.commit('SET_USER_LIST', {
        isLoading: false,
        data: response.data
      })
    } catch (err) {
      context.commit('SET_USER_LIST', {
        isLoading: false,
        data: false
      })
      notificationDanger(err)
    }
  },
  async getDetailUser(context, payload) {
    try {
      context.commit('SET_DETAIL_USER', {isLoading: true})
      const response = await apiGetAuth(API_USER.BY_ID(payload))
      context.commit('SET_DETAIL_USER', {
        isLoading: false,
        data: response.data
      })
    } catch (error) {
      context.commit('SET_DETAIL_USER', {
        isLoading: false,
        data: false
      })
      notificationDanger(error)
    }
  },
  async createUser (context, payload) {
    try {
      const response = await apiPostAuth(API_USER.CREATE_USER, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updateUser (context, payload) {
    try {
      const response = await apiPutAuth(API_USER.BY_ID(`${payload.id}?lang=id`), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async deleteUser(context, payload) {
    try {
      const response = await apiDeleteAuth(API_USER.BY_ID(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '',
        description: '',
        type: '',
        customTitleBtnOk: '',
        customTitleBtnCancel: '',
        customClass: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  get_user_list: state => {
    return state.user_list
  },
  get_detail_user: state => {
    return state.detail_user
  },
  get_data_modal_add_edit: state => {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard: state => {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter: state => {
    return state.meta_filter
  }
}

const namespaced = true
export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}
